<template>
  <div class="video-background" @click="handleClick">
    <video v-if="videoPath !== ''" :src="videoPath" loop autoplay muted></video>
  </div>
</template>

<script>
export default {
  name: 'VideoBackground',
  components: {},
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      videoPath: '',
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function() {
        this.handeSetVideo();
      },
    },
  },
  created() {
    this.handeSetVideo();
  },
  methods: {
    handleClick(e) {
      e.stopPropagation();
      this.$store.commit('set_CurrentConfigration', this.Configuration);
    },
    handeSetVideo() {
      if (this.Configuration?.propertyData?.backgroundVideo?.value) {
        this.videoPath = this.Configuration?.propertyData?.backgroundVideo?.value;
      }
    },
  },
  computed: {},
  Configuration: {
    componentTitle: '视频背景',
    componentName: 'VideoBackground',
    componentOverViewImg: './img/backgrounds/VideoBackground.png',
    propertyData: {
      backgroundVideo: {
        propertyComponentName: 'VideosUploader',
        value: '#',
        lable: '视频路径',
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.video-background {
  overflow: hidden;
  color: white;
  background-color: rgb(15, 15, 15);
  width: 100%;
  height: 100%;
  video {
    width: 100%;
    height: 100%;
  }
}
</style>
